import React, { Component, useEffect, useState } from 'react';
import _, { set } from 'lodash';
import './Standouts.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faAngleRight, faRight } from '@fortawesome/pro-solid-svg-icons';
import { faRightLeft } from '@fortawesome/pro-regular-svg-icons';
import { useHitTracking } from '../../context/hit-tracking-context';

const Categories = (props) => { // props.categories  , props.selectedCategory
    const { trackInteraction } = useHitTracking();
    const [categories, setCategories] = useState();
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeDataId, setActiveDataId] = useState(null);
    const [selectedCategoryItem, setSelectedCategoryItem] = useState(0);
    const [selectedSubCategoryItem, setSelectedSubCategoryItem] = useState(null);


    useEffect(() => {
        if (props.categories && props.categories.length > 0) {
            setCategories(props.categories);
        }
    }, [props.categories]);


    const handleMouseEnter = index => {
        setActiveIndex(index);
    };

    const handleMouseLeave = () => {
        setActiveIndex(-1);
    };


    const handleItemClick = (dataId, index, columnsData, categoryName) => {
        console.log("Tıklanan öğenin dataId'si:", dataId);
        console.log("Tıklanan öğenin index'i:", index);
        console.log("Tıklanan öğenin sütun verileri:", columnsData);

        trackInteraction(`category/${categoryName || dataId}`);

        setActiveDataId(dataId);
        setActiveIndex(index);
        setSelectedCategoryItem(index);
        setSelectedSubCategoryItem(dataId);
        props.selectedCategory(dataId)
        props.selectedColumns(columnsData, dataId)
    };

    return (
        <div className='categories-component'>

            <div className="menu-container">
                <ul className="category-list">
                    {categories && categories.map((category, index) => (
                        <li
                            key={index}
                            className={`category-item ${selectedCategoryItem === index ? "active" : ""}`}
                            onMouseEnter={() => handleMouseEnter(index)}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => category.items && category.items.length === 1 ? handleItemClick(category.items[0].dataId, index, category.items[0].grid.columns, category.name) : null}
                        >
                            <div className='expand-row'>
                                <span>
                                    {category.name}
                                </span>
                                {
                                    category.items && category.items.length > 1 && (
                                        <span className="arrow">
                                            <FontAwesomeIcon icon={faAngleRight} className={`${index === activeIndex ? "active" : ""}`} />
                                        </span>
                                    )
                                }
                            </div>


                            {index === activeIndex && category.items && category.items.length > 1 && (
                                <ul className="sub-category-list">
                                    {category.items.map((subItem, subIndex) => (
                                        <li key={subIndex} className={`sub-category-item ${selectedSubCategoryItem === subItem.dataId ? "active" : ""}`}>
                                            <span className={`${selectedCategoryItem === index ? "active" : ""}`} onClick={() => handleItemClick(subItem.dataId, index, subItem.grid.columns, subItem.name)}>
                                                {subItem.name}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
export default Categories;